import { InvertedRadioOption } from 'src/components/Input/RadioInput/InvertedRadioInput';
import styled from 'styled-components';

export const FilterModalHeader = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  gap: 1em;
  border-bottom: 1px solid ${(props) => props.theme.black[50]};
`;

export const FilterSortOrder = styled.div`
  ${InvertedRadioOption}{
    white-space: nowrap;  
  } 
`;

export const FilterSearchBar = styled.div`
`;

export const FilterModalOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 25%;
    margin-bottom: 5px;
  }
`;

